import type { AiCapabilityPage } from "../schema.js";
import { LIVE, ALL_ROLES } from "./_shared.js";

/**
 * `GRP-OPEN` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/groups` (ADR-0009 bất biến 5).
 * Cửa mobile trang này chịu trách nhiệm (cửa vào của mọi việc còn lại — trang này giữ hai cửa ĐỌC nền mà mọi màn đều gọi).
 */
export const GRP_OPEN = {
  id: "GRP-OPEN",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: ALL_ROLES,
  flags: [],
  slots: [],
  llm: {
    description: "Mở danh sách nhóm của bạn hoặc mở thẳng một nhóm để xem tổng quan.",
    examples: [
      "mở nhóm",
      "mo nhom",
      "vào nhóm lớp 5a",
      "danh sách nhóm",
      // ——— 0105: thêm cho đủ 40 ———
      "vao nhom lop 5a",
      "danh sach nhom",
      "mở danh sách nhóm",
      "mo danh sach nhom",
      "vào nhóm của tôi",
      "vao nhom cua toi",
      "mở nhóm lớp 3A",
      "mo nhom lop 3a",
      "cho tôi xem các nhóm",
      "cho toi xem cac nhom",
      "mở nhóm đội bóng công ty",
      "mo nhom doi bong cong ty",
      "xem tổng quan nhóm",
      "xem tong quan nhom",
      "mở trang nhóm",
      "mo trang nhom",
      "vào nhóm hội đồng hương",
      "vao nhom hoi dong huong",
      "mở màn hình nhóm giúp mình",
      "mo man hinh nhom giup minh",
      "các nhóm của tôi",
      "cac nhom cua toi",
      "mở nhóm gia đình",
      "mo nhom gia dinh",
      "vào xem nhóm cái",
      "vao xem nhom cai",
      "mở nhóm lên xem",
      "mo nhom len xem",
      "cho vào nhóm quỹ lớp",
      "cho vao nhom quy lop",
      "trang nhóm ở đâu?",
      "trang nhom o dau",
      "mở group",
      "mo group",
      "vào nhóm đi",
      "vao nhom di",
    ],
  },
  screen: "/groups",
  screenShows: "group_list",
  endpoints: [
    "GET /users/me/groups",
    "GET /groups/{groupId}",
  ],
  facts: [],
  templates: {
    redirect: "Mình mở danh sách nhóm của bạn nhé.",
  },
  journey: { after: ["READ-FUND-MONEY"] },
  help: { title: "Mở nhóm", tryNow: "mở nhóm" },
} satisfies AiCapabilityPage;
